"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _FemaGoTable = _interopRequireDefault(require("./tables/femaGoTable/FemaGoTable"));
var _utils = require("../../../common/requestDetails/v2/utils");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var requestDetailsSummaryTable = function requestDetailsSummaryTable(json) {
  var requestDetailsData = json.requestDetailsData,
    itemData = json.itemData,
    summary = json.summary;
  var aggregates = {
    aggregratedtotalCount: 0,
    aggregratedtotalCost: 0
  };
  var requestDetails = _lodash.default.values(requestDetailsData);
  var getitemdesc = function getitemdesc(itemCode) {
    var itemRefData = _lodash.default.values(itemData);
    var itemDetail = _lodash.default.find(itemRefData, function (item) {
      return item.itemCode === itemCode;
    });
    var name = _lodash.default.get(itemDetail, 'name');
    return name;
  };
  var renderTable = function renderTable(requestDetails) {
    var activityObjs = [];
    var totals = 0;
    _lodash.default.forEach(requestDetails, function (obj) {
      _lodash.default.forEach(_lodash.default.values(obj['children']), function (obj) {
        if (obj['children']) {
          _lodash.default.forEach(_lodash.default.values(obj['children']), function (obj) {
            activityObjs.push(obj);
          });
        } else {
          activityObjs.push(obj);
        }
      });
    });
    var requestBody = activityObjs.map(function (obj, index) {
      totals = (0, _utils.getTotalCountAndCost)(obj, aggregates);
      return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
        width: 3
      }, getitemdesc(_lodash.default.get(obj, 'itemCode'))), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
        width: 3
      }, totals[0]), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
        width: 3
      }, totals[1]));
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, requestBody, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, null, /*#__PURE__*/_react.default.createElement("b", null, "Total")), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
      width: 3
    }, totals[2]), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
      width: 3
    }, totals[3])));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Header, {
    as: "h4"
  }, "Grant request summary"), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default, {
    summary: summary
  }, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Header, null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, null, "Category"), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, null, "Number of sub-categories"), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, null, "Total cost"))), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Body, null, renderTable(requestDetails))));
};
var _default = requestDetailsSummaryTable;
exports.default = _default;